import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Section({
  title,
  children
}) {
  return /*#__PURE__*/_jsxs(View, {
    borderColor: "border-core-subtle",
    borderWidth: "100",
    borderStyle: "solid",
    borderRadius: "200",
    paddingBlock: "200",
    paddingInline: "300",
    backgroundColor: "fill-surface-default",
    children: [title && /*#__PURE__*/_jsx(Text, {
      typography: "heading-25",
      color: "text-core-default",
      marginBlockEnd: "300",
      children: title
    }), /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      gap: "200",
      children: children
    })]
  });
}